<template>
    <div class="Pla-EscalaModelo-Menu">
        <PageTitle icon="fa fa-map" main="Escala Modelo"
            sub="Inforções da escala diária" />
        <div class="Pla-EscalaModelo-Menu">
            <b-card no-body>
                <b-tabs>                                        
                    <b-tab title="Gestão da operação" active><GestaoOperacao /></b-tab>    
                    <b-tab title="Tabelas alteradas"><EscTabelasDiariasAlteradas /></b-tab>                                                                                                                                                                
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import GestaoOperacao from '../pla_linha/GestaoOperacao'
import EscTabelasDiariasAlteradas from '../trafego/TrafegoTabelaAlterada'
//import RequisicaoPainel from '../estoque/RequisicaoPainel'

export default {
    name: 'PlantaoMenu',    
    components: { PageTitle, GestaoOperacao,EscTabelasDiariasAlteradas}    
}
</script>

<style>

</style>






